// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kr998-header {
  background: #ffffff;
  padding: 4px 8px;
  border-bottom: 1px solid black;
}

.kr998-header h1 {
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  color: #181818;
  text-align: left;
}

.new-kr998-fg {
  width: 100%;
  margin-bottom: 15px;
}

.new-kr998-fg label {
  display: block;
  margin-bottom: 2px;
  font-size: 0.775rem;
}

.new-kr998-fg select,
.new-kr998-fg input {
  width: 100%;
  padding: 4px;
  font-size: 0.775rem;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-kr998/ert-new-kr998/ert-new-kr998.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".kr998-header {\n  background: #ffffff;\n  padding: 4px 8px;\n  border-bottom: 1px solid black;\n}\n\n.kr998-header h1 {\n  font-size: 16px;\n  font-weight: 400;\n  margin: 0;\n  color: #181818;\n  text-align: left;\n}\n\n.new-kr998-fg {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.new-kr998-fg label {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 0.775rem;\n}\n\n.new-kr998-fg select,\n.new-kr998-fg input {\n  width: 100%;\n  padding: 4px;\n  font-size: 0.775rem;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
